import ReceptionView from "@features/achats/components/receptions/ReceptionView";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Inbox } from "lucide-react";

export const Route = createFileRoute("/_app/achats/receptions/$id/view")({
  staticData: {
    title: "Détails Bon de Réception",
    icon: Inbox,
    permission: PERMISSIONS.ACHATS.RECEPTIONS.VIEW,
    module: "achats",
    showInTab: false,
    showInNav: false,
    showInBreadcrumb: true,
  },
  component: ReceptionView,
});
